import { useTranslation } from 'react-i18next';
import type { UserRole } from '@/api/models';
import { getUser } from '@/utils';
import {
    ONBOARDING_FALLBACK,
    useOnboardingSession,
} from '../useOnboardingSession';

/** Role → `layout.profile.roles.*`, the sidebar's role labels. */
const ROLE_KEY: Record<UserRole, string> = {
    BranchAdmin: 'branchAdmin',
    OrgAdmin: 'orgAdmin',
    Seller: 'seller',
};

export type UseSetupPendingPageResult = {
    organisationName: string;
    userName: string;
    roleLabel: string;
    isSigningOut: boolean;
    onSignOut: () => void;
};

/**
 * The setup-in-progress page's values: the organisation name and Sign out
 * (shared with the wizard, `useOnboardingSession`) plus who is signed in.
 */
export const useSetupPendingPage = (): UseSetupPendingPageResult => {
    const { t } = useTranslation('components');
    const session = useOnboardingSession();
    const user = getUser();

    return {
        organisationName: session.organisationName,
        userName: user?.name?.trim() || ONBOARDING_FALLBACK,
        roleLabel: user?.role
            ? t(`layout.profile.roles.${ROLE_KEY[user.role]}`)
            : ONBOARDING_FALLBACK,
        isSigningOut: session.isSigningOut,
        onSignOut: session.onSignOut,
    };
};
